import React, {useContext, useState} from "react";
import {saveData} from "../../helpers/Api";
import {Button, Col, Row} from "react-bootstrap";
import FlashMessage from "../shared/FlashMessage";
import {useMutation} from "@apollo/client";
import {updateProfileQuery} from "./UserQueries";
import UploadFile from "../shared/UploadFile";
import {AuthContext} from "../../context/authContext";

const Profile = () => {
  const [flash, setFlash] = useState({});
  const [updateCall] = useMutation(updateProfileQuery)
  // const user = CurrentUser()
  const { saveUser, user } = useContext(AuthContext)

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: updateCall,
      query_key: 'updateUser',
      flash_callback: setFlash,
      success: (res) => {
        saveUser(res.user)
      }
    })
  }

  const onAvatarChange = (res) => {
    saveUser({ ...user, avatar: res.path })
  }

  return (
    <div className="container">
      <div className='d-sm-flex align-items-center mb-4 mt-4'>
        <Col className='flex-shrink-0 me-2'>
          {user.email &&
            <UploadFile model='Provider' id={user.id} field='avatar'
                        filePath={user.avatar} onChange={onAvatarChange} />}
        </Col>
        <Col sm={7} className='flex-grow-1 border p-3 rounded shadow bg-body'>
          <form onSubmit={onSubmit}>
            <Row className="mb-2">
              <Col>
                <label htmlFor="fName">Prenume</label>
                <input type='text' name='fName' className="form-control" id="fName" defaultValue={user.fName} />
              </Col>
              <Col>
                <label htmlFor="lName">Nume</label>
                <input type="text" name='lName' className="form-control" id="lName" defaultValue={user.lName} />
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <label htmlFor="phone">Telefon</label>
                <input type="text" name='phone' className="form-control" id="phone" defaultValue={user.phone} />
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <label htmlFor="email">Email</label>
                <input type="email" name="email" className="form-control" id="email" defaultValue={user.email} />
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <label htmlFor="password">Parola</label>
                <input type="password" name="password" className="form-control" id="password" defaultValue='' />
              </Col>
            </Row>
            <FlashMessage flash={flash} buttons={<Button type='submit' className='float-end'>Salveaza</Button>} />
          </form>
        </Col>
      </div>

      {/*<Tabs>*/}
      {/*  <Tab eventKey='calendar' title='Calendar'>*/}
      {/*    <div className='border border-top-0 p-3 rounded-bottom shadow'>*/}
      {/*      <CalendarView appointments={appointments}/>*/}
      {/*    </div>*/}
      {/*  </Tab>*/}
      {/*  <Tab eventKey='appointments' title='Programari'>*/}
      {/*    <div className='border border-top-0 p-3 rounded-bottom shadow'>*/}
      {/*      <AppointmentsList appointments={appointments}/>*/}
      {/*    </div>*/}
      {/*  </Tab>*/}
      {/*  {currentUser().role == 'provider' &&*/}
      {/*    <Tab eventKey='clients' title='Clienti'>*/}
      {/*      <div className='border border-top-0 p-3 rounded-bottom shadow'>*/}
      {/*        <ClientsList clients={clients}/>*/}
      {/*      </div>*/}
      {/*    </Tab>*/}
      {/*  }*/}
      {/*  {currentUser().role == 'client' &&*/}
      {/*    <Tab eventKey='users' title='Angajati'>*/}
      {/*      <div className='border border-top-0 p-3 rounded-bottom shadow'>*/}
      {/*        <ClientsList users={users}/>*/}
      {/*      </div>*/}
      {/*    </Tab>*/}
      {/*  }*/}
      {/*  <Tab eventKey='orgs' title='Organizatii'>*/}
      {/*    <div className='border border-top-0 p-3 rounded-bottom shadow'>*/}
      {/*      <OrganizationsList orgs={user.organizations}/>*/}
      {/*    </div>*/}
      {/*  </Tab>*/}

      {/*</Tabs>*/}
    </div>
  );
}

export default Profile
